module.exports = __webpack_public_path__ + "img/5-1.dda2c32f.png";